import React, { useEffect, useState } from 'react';
import SelectAutoComplete from 'components/Tvendo/Common/SelectAutoComplete';
import RegularButton from 'components/CustomButtons/Button';
import ModalBase from 'components/Tvendo/Common/ModalBase';
import { wsGetAll, wsPost } from 'services/WService';

function AddSellerMarkModal(props) {
  const { model, setOpen, setSellerMarks, showNotify } = props;
  const [marks, setMarks] = useState([]);
  const [selectedMark, setSelectedMark] = useState();
  const [processing, setProcessing] = useState(false);

  async function listMarks() {
    let res = await wsGetAll('logi/mark');
    if (res.success) setMarks(res.data);
  }
  async function addMark() {
    setProcessing(true);
    let res = await wsPost(`base/seller/${model.id}/mark`, {
      logi_mark_id: selectedMark.id,
    });
    setProcessing(false);

    if (res.success) {
      showNotify(res.message);
      setSellerMarks(res.data);
      setOpen({ open: false });
    } else {
      showNotify(res.message, 'error');
    }
  }

  useEffect(() => {
    listMarks();
  }, []);

  return (
    <ModalBase
      title={`Agregar Marca`}
      maxWidth="sm"
      fullWidth
      model={model}
      setOpen={setOpen}
      entity=""
      hideSave
      footerComponent={
        <RegularButton
          color="success"
          size="sm"
          onClick={addMark}
          disabled={processing || selectedMark === undefined}
        >
          Agregar
        </RegularButton>
      }
    >
      <SelectAutoComplete
        label="Marca"
        required
        options={marks}
        selectedOption={selectedMark}
        setSelectedOption={setSelectedMark}
        disabled={processing}
      />
    </ModalBase>
  );
}

export default AddSellerMarkModal;
